import find from 'lodash/find';
import get from 'lodash/get';

const isCustomImage = (selectedImage, coverPageImages) => {
  return !!selectedImage.src && coverPageImages.custom.some(item => item.imageUri === selectedImage.src);
};
export const trackCoverPageProperties = (payload, properties, singleLineAddress, selectedImage, coverPageImages) => {
  const coverData = find(payload.sections, {name: 'COVER_PAGE'});
  if (coverData) {
    const coverItems = {
      'Title': !!coverData.title,
      'Address': !!coverData.data.singleLineAddress,
      'Agency logo': !!coverData.data.agencyLogoUri,
      'Agent details': !!coverData.data.agentDetails,
      'Prepared on': coverData.data.preparedText && coverData.data.preparedText.includes('Prepared on'),
      'Prepared for': coverData.data.preparedText && coverData.data.preparedText.includes('Prepared for')
    };
    const coverItemsIncluded = Object.keys(coverItems).filter(key => coverItems[key] === true).map((s) => s);
    properties.push(...[
      {label: 'Cover Page Address', value: get(coverData.data, 'singleLineAddress', singleLineAddress)},
      {
        label: 'Select Cover Image',
        value: isCustomImage(selectedImage, coverPageImages),
      },
      {label: 'Cover Page Sections Included', value: coverItemsIncluded},
    ]);
  }
};